module.exports = __webpack_public_path__ + "static/media/galerija_2022_0041.0c7a85bb.jpg";